import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import Api from '../../../Apis/api.service'
import { CustomFileDetailTable } from '../../../components/file_upload'
import Pagination from '@mui/material/Pagination'
import SelectChips from '../../../components/common/Select/Chips'
import Utils from '../utils'
import { ContentPasteGoOutlined } from '@mui/icons-material'
import { filterTypesByCategories } from '../../../utils'

export const DocsCopro = ({ id, coproprietaire_id }) => {
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [total, setTotals] = useState(1)
  const [filter, setFilter] = useState({
    categories: [],
    types: [],
    onlyMine: false,
  })

  const [types, setTypes] = useState([])
  const [defaultTypes, setDefaultTypes] = useState(Utils.docsCopros.types)
  const [categories, setCategories] = useState([])
  const fetchFiles = async (params) => {
    const res = await Api.copros.getFiles(coproprietaire_id, params)
    if (res.status == 200) {
      setData(() => {
        return res.data?.data
      })
      setTotals(() => {
        return res.data.pagination.totalPages
      })
    }
  }
  const getChoices = async () => {
    const res = await Api.copros.getChoicesDocs(coproprietaire_id, {
      filter: JSON.stringify({ onlyMine: filter.onlyMine }),
    })
    if (res.status == 200) {
      setCategories(() => {
        return Utils.docsCopros.categories.filter((categorie) =>
          res.data?.categories.includes(categorie.id)
        )
      })
      setDefaultTypes(() => {
        return Utils.docsCopros.types.filter((type) =>
          res.data?.types.includes(type.id)
        )
      })
      setTypes(() => {
        return Utils.docsCopros.types.filter((type) =>
          res.data?.types.includes(type.id)
        )
      })
    }
  }
  useEffect(() => {
    getChoices()
  }, [coproprietaire_id, filter.onlyMine])

  useEffect(() => {
    let filtredTypes = filterTypesByCategories(
      filter.categories.map((item) => item.id),
      defaultTypes
    )
    setTypes(() => {
      return filtredTypes
    })
  }, [filter.categories])
  useEffect(() => {
    let params = {
      pagination: JSON.stringify({ page, limit: 10 }),
      filter: JSON.stringify({
        ...filter,
        categories: Array.from(filter.categories, ({ id }) => id),
        types: Array.from(filter.types, ({ id }) => id),
      }),
    }
    fetchFiles(params)
  }, [page, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])
  return (
    <>
      <Box component={Paper} padding={'20px'} marginBottom={'10px'}>
        {/* <Filter> */}
        <Typography variant="h6">Filtres</Typography>
        <Box
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <SelectChips
            label="Categories"
            idKey={'id'}
            labelKey={'name'}
            options={categories}
            values={filter.categories}
            setValues={(vals) => {
              setFilter(() => {
                return {
                  ...filter,
                  categories: vals,
                }
              })
            }}
          />
          <SelectChips
            label="Types"
            idKey={'id'}
            labelKey={'name'}
            options={types}
            values={filter.types}
            setValues={(vals) => {
              setFilter(() => {
                return { ...filter, types: vals }
              })
            }}
          />
          <FormControlLabel
            style={{
              marginLeft: '0px',
            }}
            control={
              <Checkbox
                checked={filter.onlyMine}
                onChange={(e) => {
                  setFilter({ ...filter, onlyMine: !filter.onlyMine })
                }}
              />
            }
            label="Mes fichiers uniquement"
          />
        </Box>
      </Box>
      <Box component={Paper} padding={'20px'} marginBottom={'10px'}>
        <CustomFileDetailTable rows={data} responsive={true} />
        <Box
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: '10px',
          }}
        >
          <Pagination
            count={total}
            color="primary"
            page={page}
            onChange={(event, value) => {
              setPage(value)
            }}
          />
        </Box>
      </Box>
    </>
  )
}
export default DocsCopro
